import { css } from "lit";

export const styles = css`
  :host {
    display: contents;

    /* Animation duration as unitless seconds for JavaScript access */
    --drawer-animation-duration-s: 0.3;

    /* Animation duration as CSS time unit for transitions */
    --drawer-animation-duration: calc(var(--drawer-animation-duration-s) * 1s);
  }

  :host([data-closing]) .drawer-overlay {
    opacity: 0;
  }

  :host([data-closing]) .drawer-overlay::backdrop {
    background: transparent;
    backdrop-filter: none;
  }

  :host([data-closing]) .drawer-content {
    transform: translateY(100%);
  }

  .drawer-overlay {
    overflow: hidden;
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100dvh;
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    opacity: 1;
    z-index: 9999; /* Ensure drawer appears above all content */
    transition:
      opacity var(--drawer-animation-duration) ease-out,
      display var(--drawer-animation-duration) allow-discrete,
      overlay var(--drawer-animation-duration) allow-discrete;
  }

  .drawer-overlay:not(:popover-open) {
    opacity: 0;
  }

  .drawer-overlay::backdrop {
    background: var(--sds-color-background-utilities-overlay);
    backdrop-filter: blur(var(--sds-size-blur-100));
    pointer-events: all;
    transition:
      background var(--drawer-animation-duration) ease-out,
      backdrop-filter var(--drawer-animation-duration) ease-out,
      display var(--drawer-animation-duration) allow-discrete,
      overlay var(--drawer-animation-duration) allow-discrete;
  }

  .drawer-overlay:not(:popover-open)::backdrop {
    background: transparent;
    backdrop-filter: none;
  }

  @starting-style {
    .drawer-overlay:popover-open {
      opacity: 0;
    }

    .drawer-overlay:popover-open::backdrop {
      backdrop-filter: none;
    }

    .drawer-content {
      transform: translateY(100%);
    }
  }

  .drawer-content {
    margin: 0;
    padding: 0;
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-default);
    border-radius: var(--sds-size-radius-600) var(--sds-size-radius-600) 0 0;
    box-shadow:
      0 var(--sds-size-depth-400) var(--sds-size-depth-800) var(--sds-size-depth-negative-100)
        var(--sds-color-black-200),
      0 var(--sds-size-depth-200) var(--sds-size-depth-200) var(--sds-size-depth-negative-100)
        var(--sds-color-black-100);
    width: 100%;
    max-width: 393px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transform: translateY(0);
    transition: transform var(--drawer-animation-duration) ease-out;
  }

  .drawer-overlay:not(:popover-open) .drawer-content {
    transform: translateY(100%);
  }

  .drawer-header {
    position: relative;
    padding: var(--sds-size-space-600) var(--sds-size-space-600) 0 var(--sds-size-space-600);
    border-bottom: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .drawer-header slot[name="header"] {
    flex: 1;
    text-align: center;
    font-family: var(--sds-typography-family-title);
    font-weight: var(--sds-typography-weight-medium);
    font-size: var(--sds-typography-scale-03);
    line-height: 1.5;
    color: var(--sds-color-text-default-default);
    padding: var(--sds-size-space-600) 0;
    display: block;
  }

  .drawer-body {
    padding: var(--sds-size-space-800);
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
    flex-shrink: 0;
  }

  .drawer-body ::slotted(wow-button) {
    --wow-button-display: block;
    --wow-button-width: 100%;
    --wow-button-inner-display: flex;
    --wow-button-inner-width: 100%;
  }

  /* Mobile-first responsive design */
  @media (min-width: 768px) {
    .drawer-content {
      max-width: 400px;
      border-radius: var(--sds-size-radius-600);
      margin-bottom: var(--sds-size-space-1200);
    }

    .drawer-body {
      flex-direction: row;
      gap: var(--sds-size-space-400);
    }

    .drawer-body ::slotted(wow-button) {
      --wow-button-display: inline-block;
      --wow-button-width: auto;
      --wow-button-inner-display: inline-flex;
      --wow-button-inner-width: auto;
      flex: 1;
    }
  }
`;
